import { PUBLIC_API_URL } from '$env/static/public';
import type { RequestEvent } from '@sveltejs/kit';

export class Api {
  baseUrl = PUBLIC_API_URL;
  constructor(protected fetch: RequestEvent['fetch']) {}
}
